import { colors } from '../../colors';
var pagination = {
  activeColor: colors.neonPurple,
  defaultColor: colors.slateGrey
};
export default pagination;